import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';

// get auth state slice from the full state
const useSelectedSystemTaxYear = () => useSelector((state: RootState) => state?.selectedTaxYear || '');

export default useSelectedSystemTaxYear;